module.exports = __webpack_public_path__ + "static/media/CHAWV_MENU-normal.074ef37c.png";